import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { BellRinging, BellSimple } from "@phosphor-icons/react";
import { formatDate } from "@/lib/format";

const ClientNotifications = () => {
  const [items, setItems] = useState([]);

  const load = async () => {
    try { const { data } = await api.get("/client/notifications"); setItems(data); }
    catch {}
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    try { await api.post(`/client/notifications/${id}/read`); load(); } catch {}
  };

  return (
    <div className="space-y-5">
      <div>
        <p className="text-xs tracking-[0.3em] uppercase text-zinc-500 font-semibold">Mensagens</p>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight mt-1">Avisos</h1>
      </div>

      {items.length === 0 ? (
        <Card className="border-zinc-200 rounded-2xl p-10 text-center text-zinc-500 card-soft">
          <BellSimple size={28} weight="duotone" className="mx-auto mb-2 text-zinc-400"/>
          Você está em dia! Nenhum aviso pendente.
        </Card>
      ) : (
        <div className="space-y-3">
          {items.map((n) => (
            <Card
              key={n.id}
              onClick={() => !n.read && markRead(n.id)}
              data-testid={`client-notif-${n.id}`}
              className={`border rounded-2xl p-5 card-soft cursor-pointer transition-colors ${n.read ? "border-zinc-200 bg-white" : "border-blue-200 bg-blue-50/40 hover:bg-blue-50"}`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded-xl grid place-items-center ${n.read ? "bg-zinc-100 text-zinc-500" : "bg-blue-100 text-blue-700"}`}>
                  <BellRinging size={18} weight={n.read ? "regular" : "fill"}/>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2 flex-wrap">
                    <div className="font-medium">{n.title}</div>
                    <div className="text-xs text-zinc-500">{formatDate(n.created_at)}</div>
                  </div>
                  <div className="text-sm text-zinc-600 mt-1">{n.message}</div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClientNotifications;
